import { Pencil, Trash2 } from 'lucide-react';
import type { Participant } from '../../types/api';
import { formatCPF, formatPhone, formatCEP } from '../../types/api';
import { DataTable } from '../ui';

interface ParticipantListProps {
  participants: Participant[];
  onEdit: (participant: Participant) => void;
  onDelete: (participant: Participant) => void;
  isLoading?: boolean;
}

function ParticipantList({ participants, onEdit, onDelete, isLoading }: ParticipantListProps) {
  const columns = [
    {
      header: 'CPF',
      accessorKey: 'cpf' as const,
      cell: (row: Participant) => formatCPF(row.cpf),
    },
    {
      header: 'Nome',
      accessorKey: 'full_name' as const,
    },
    {
      header: 'Cidade',
      accessorKey: 'city' as const,
      cell: (row: Participant) => row.city || '-',
    },
    {
      header: 'CEP',
      accessorKey: 'postal_code' as const,
      cell: (row: Participant) => (row.postal_code ? formatCEP(row.postal_code) : '-'),
    },
    {
      header: 'Telefone',
      accessorKey: 'phone' as const,
      cell: (row: Participant) => (row.phone ? formatPhone(row.phone) : '-'),
    },
    {
      header: 'Email',
      accessorKey: 'email' as const,
      cell: (row: Participant) => row.email || '-',
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={participants}
      onEdit={onEdit}
      onDelete={onDelete}
      isLoading={isLoading}
    />
  );
}

export default ParticipantList;
